<template>
  <div>
    <Notification />
    <Balance />
    <Report :enable="true"/>
  </div>
</template>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import Notification from "@/components/Notification";
import Balance from "@/components/Balance";
import Report from "./Report2.vue"
export default {
  name: "dashboard",
  components: { Notification, Balance, Report },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "داشبورد مدیریت" }]);
  },
 
};
</script>

